"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationStepDto = void 0;
class NotificationStepDto {
}
exports.NotificationStepDto = NotificationStepDto;
